import { DashboardOutlined, SettingOutlined } from '@ant-design/icons'
import UnauthorizedScreen from 'Components/Auth/UnauthorizedScreen'
import OrganisationAvatar from 'Components/Avatar/OrganisationAvatar'
import MenuItem from 'Components/Menu/MenuItem'
import SubMenu from 'Components/Menu/SubMenu'
import { useCurrentOrganisation } from 'Hooks/useCurrentOrganisation'
import { HomeRow, MenuTitle } from 'Layouts/styled'
import { AuthorizationWrapperV2 } from 'Models/AuthorizeV2/checkAuthorizationV2'
import { useGetFlow } from 'Pages/Home/Templates/actions'
import navMenuStyles from 'Styles/NavMenu.module.scss'
import PolicyMappings from 'Utils/policyMapping'
import { useLocationReference } from 'Utils/useLocationReference'
import { useMemo, useState } from 'react'
import { Outlet, useLocation } from 'react-router'
import AuthBaseLayout from '../AuthBaseLayout'

const buildMenus = ['/instructions', '/prompts', '/attributes']

export const SmsTemplateLayout = () => {
  const location = useLocation()
  const { organisationUUID, flowUUID } = useLocationReference()

  const [activeSubMenu, setActiveSubMenu] = useState<string>('')

  const { organisation } = useCurrentOrganisation()
  const { data: flow } = useGetFlow({
    flow_uuid: flowUUID,
    organisationUuid: organisationUUID,
  })

  const selected: any = useMemo(() => {
    if (buildMenus.some((x) => location.pathname.includes(x))) {
      return { build: true }
    }
    return false
  }, [location.pathname])

  return (
    <AuthorizationWrapperV2
      requiredPolicies={PolicyMappings.smsAgentsView}
      unauthorizedComponent={<UnauthorizedScreen />}
    >
      <AuthBaseLayout
        collapsibleSideNav={true}
        sideNavTheme="dark"
        className={[navMenuStyles['menu-item'], navMenuStyles['menu-item__dark']].join(' ')}
        sideMenuProps={{
          style: {
            backgroundColor: 'var(--blue-600)',
          },
          theme: 'dark',
          defaultOpenKeys: [],
        }}
        menu={[
          <SubMenu
            key="config-sub-menu"
            title={'Build'}
            submenuKey={'build'}
            activeKey={activeSubMenu}
            icon={<DashboardOutlined />}
            defaultOpen={selected.build}
            selected={selected.build}
            theme="dark"
            onOpen={() => setActiveSubMenu('build')}
          >
            <MenuItem
              key="instructions"
              subMenuItem
              to={`instructions`}
              selected={location.pathname.includes('instructions')}
              theme="dark"
            >
              Instructions
            </MenuItem>
            <MenuItem
              key="prompts"
              subMenuItem
              to={`prompts`}
              selected={location.pathname.includes('prompts')}
              theme="dark"
            >
              Prompts
            </MenuItem>
            <MenuItem
              key="attributes"
              subMenuItem
              to={`attributes`}
              selected={location.pathname.includes('attributes')}
              theme="dark"
            >
              Attributes
            </MenuItem>
          </SubMenu>,
        ]}
        headerRender={({ theme, collapsed }: any) => {
          return (
            <HomeRow theme={theme}>
              <OrganisationAvatar name={organisation?.name} />
              {!collapsed ? <MenuTitle theme={theme}>{flow?.name || ''}</MenuTitle> : null}
            </HomeRow>
          )
        }}
        bottomMenu={[
          <MenuItem
            style={{
              marginTop: 'auto',
            }}
            key="settings"
            to={`/clients/${organisation?.uuid}/sms-template/${flow?.uuid}/settings`}
            icon={<SettingOutlined />}
            theme="dark"
          >
            Template Settings
          </MenuItem>,
        ]}
        id="sms-config-layout"
      >
        <Outlet />
      </AuthBaseLayout>
    </AuthorizationWrapperV2>
  )
}
